<template>
    <el-container class="app-layout">
        <!-- Navbar -->
        <el-header class="app-header p-0" height="1">
            <el-row justify="space-between" align="middle" class="p-2 col-12">
                <el-col class="col-auto">
                    <el-button
                        icon="Menu"
                        @click="toggleSidebar" 
                        class="menu-toggle-button"
                    ></el-button>
                    <span class="app-title">DashBoard Beasy </span>
                </el-col>
                <el-row align="middle" :gutter="15">
                    <el-col class="d-none d-sm-inline col-auto">
                        <el-tooltip
                            effect="light"
                            content="Modo tela cheia"
                            placement="bottom"
                        >
                            <el-icon role="button" @click="toggleFullscreen">
                                <Rank v-if="isFullscreen"/>
                                <FullScreen v-else />
                            </el-icon>
                        </el-tooltip>
                    </el-col>
                    <el-col class="col-auto">
                            <el-tooltip
                                effect="light"
                                content="Terminar sesssao"
                                placement="bottom"
                            >
                                <el-icon shape="circle" role="button" @click="logout">
                                    <SwitchButton />
                                </el-icon>
                            </el-tooltip>
                    </el-col>
                </el-row>
            </el-row>
        </el-header>
        <!-- ./Navbar -->

        <div class="px-3 py-3" style="background: #409EFF;">
            <form @submit.prevent="login" class="v-col-12">
                <ElRow class="v-col-12">
                    <ElCol :cols="25" class="px-2">
                        <h4>Inserir credenciais de entrada</h4>
                    </ElCol>
                    <ElCol :cols="24" :md="8" :lg="6">
                        <ElInput type="text" name="phone" v-model="phone"  class="px-2" />
                    </ElCol>
                    <ElCol :cols="24" :md="8" :lg="6">
                        <ElInput type="password" name="password" v-model="password" placeholder="Insira a senha"  class="px-2" />
                    </ElCol>
                    <ElCol :cols="24" :md="8" :lg="6" class="px-2">
                        <ElButton native-type="submit">Entrar</ElButton>
                    </ElCol>
                </ElRow>
            </form>
        </div>
        <!-- Sidebar and Main Content -->
        <el-container>
            <el-aside class="app-sidebar col-auto">
                <el-menu 
                    :collapse="!isSidebarOpen"
                    :default-active="activeMenu" 
                    active-text-color="#ffd04b"
                    background-color="#545c64"
                    class="el-menu-vertical-demo" 
                    router 
                    unique-opened
                    text-color="#fff"
                >
                    <el-menu-item index="/companies-dashboard" title="Perfil">
                        <el-icon><HomeFilled /></el-icon>
                        <span>Informacoes</span>
                    </el-menu-item>        
                </el-menu>
            </el-aside>
            <el-main class="">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useFullscreen } from '@vueuse/core'
    import { ElButton, ElCol, ElInput, ElRow } from 'element-plus';

    const store = useStore();
    const router = useRouter();
    const phone = ref<string>('')
    const password = ref<string>('')


    const isSidebarOpen = ref(false);
    const activeMenu = ref<string>(store.getters.route)

    router.beforeEach(route => {
        activeMenu.value = route.path
    })

    const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
    };

    const { isFullscreen, toggle: toggleFullscreen } = useFullscreen();
    
    const logout = async () => {
        sessionStorage.removeItem('password')
        sessionStorage.removeItem('phone')
        router.push("/?key=" + new Date())
    }
    
    const login = () => {
        console.log(9000)
        sessionStorage.setItem('password', password.value)
        sessionStorage.setItem('phone', phone.value)
        location.reload()
    }
</script>

<style scoped lang="scss">
.app-layout {
    height: 100vh;

    .app-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background-color: #409EFF;
        color: white;
        
        .app-title {
            font-size: 1.2em;
        }

        .menu-toggle-button {
            margin-right: 10px;
        }
    }

    .app-sidebar {
        transition: all .3s;
    
        .el-menu-vertical-demo {
            height: 100%;
            &:not(.el-menu--collapse) {
                width: 240px;
            }
        }
    }
}
</style>
